import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import Homepage from '../views/Homepage.vue'

Vue.use(VueRouter)



const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    children: [
      {
        path: '', meta: { title: '全国开奖' }, component: Homepage
      },
      {
        path: 'manual-plan',
        name: 'ManualPlan',
        meta: { title: '人工计划' },
        component: () => import('../views/ManualPlan.vue')
      },
      {
        path: 'manual-plan/detail',
        name: 'ManualPlanDetail',
        meta: { title: '计划详情' },
        component: () => import('../views/ManualPlanDetail.vue')
      },
      {
        path: 'list', meta: { title: '分类列表' }, component: () => import('../views/ChildrenCategory.vue'), props: true
      },
      {
        path: 'live',
        name: 'Live',
        meta: { title: '开奖直播' },
        component: () => import('../views/Live.vue')
      },
      {
        path: 'live/embed',
        name: 'LiveEmbed',
        meta: { title: '直播' },
        component: () => import('../views/LiveEmbed.vue')
      },
      {
        path: 'tool',
        name: 'Tool',
        meta: { title: '工具大全' },
        component: () => import('../views/Tool.vue')
      },
      {
        path: 'predict',
        name: 'Predict',
        meta: { title: '预测' },
        component: () => import('../views/Predict.vue')
      },
      {
        path: 'predict/publish',
        name: 'PredictPublish',
        meta: { title: '发布文章' },
        component: () => import('../views/PredictPublish.vue')
      },
      {
        path: 'predict/rule-publish',
        name: 'PredictRulePublish',
        meta: { title: '发布规律贴' },
        component: () => import('../views/PredictRulePublish.vue')
      },
      {
        path: 'predict/scheme',
        name: 'PredictScheme',
        meta: { title: '方案' },
        component: () => import('../views/PredictScheme.vue')
      },
      {
        path: 'predict/search',
        name: 'PredictSearch',
        meta: { title: '搜索' },
        component: () => import('../views/PredictSearch.vue')
      },
      {
        path: 'predict/detail',
        name: 'PredictDetail',
        meta: { title: '方案详情' },
        component: () => import('../views/PredictDetail.vue')
      },
      {
        path: 'predict/author',
        name: 'PredictAuthor',
        meta: { title: '专家主页' },
        component: () => import('../views/PredictAuthor.vue')
      },
      {
        path: 'predict/experts',
        name: 'PredictExperts',
        meta: { title: '全部专家' },
        component: () => import('../views/PredictExperts.vue')
      },
      {
        path: 'predict/selected',
        name: 'PredictSelected',
        meta: { title: '精选专区' },
        component: () => import('../views/PredictSelected.vue')
      },
      {
        path: 'predict/ranking',
        name: 'PredictRanking',
        meta: { title: '排行榜' },
        component: () => import('../views/PredictRanking.vue')
      },
      {
        path: 'predict/my-articles',
        name: 'PredictMineArticles',
        meta: { title: '我的文章' },
        component: () => import('../views/mine/Articles.vue')
      },
      {
        path: 'mine/favorites',
        name: 'PredictFavorites',
        meta: { title: '我的收藏' },
        component: () => import('../views/mine/Favorites.vue')
      },
      {
        path: 'mine/follows',
        name: 'MineFollows',
        meta: { title: '我的关注' },
        component: () => import('../views/mine/Relations.vue')
      },
      {
        path: 'mine/fans',
        name: 'MineFans',
        meta: { title: '我的粉丝' },
        component: () => import('../views/mine/Relations.vue')
      },
      {
        path: 'mine/orders',
        name: 'MineOrders',
        meta: { title: '我的订单' },
        component: () => import('../views/mine/Orders.vue')
      },
      {
        path: 'predict/pay-protocol',
        name: 'PredictPayProtocol',
        meta: { title: '付费协议' },
        component: () => import('../views/PredictPayProtocol.vue')
      },
      {
        path: 'community',
        name: 'Community',
        meta: { title: '社群' },
        component: () => import('../views/Community.vue')
      },
      {
        path: 'mine',
        name: 'Mine',
        meta: { title: '我的' },
        component: () => import('../views/mine/Index.vue')
      },
      {
        path: 'mine/settings',
        name: 'MineSettings',
        meta: { title: '设置' },
        component: () => import('../views/mine/settings/Settings.vue')
      },
      {
        path: 'mine/member',
        name: 'MineMember',
        meta: { title: '会员中心' },
        component: () => import('../views/mine/settings/Member.vue')
      },
      {
        path: 'mine/profile',
        name: 'MineProfile',
        meta: { title: '修改资料' },
        component: () => import('../views/mine/settings/Profile.vue')
      },
      {
        path: 'mine/password',
        name: 'MinePassword',
        meta: { title: '修改密码' },
        component: () => import('../views/mine/settings/Password.vue')
      },
      {
        path: 'mine/ledger',
        name: 'MineCoinLedger',
        meta: { title: '消费记录' },
        component: () => import('../views/mine/Ledger.vue')
      },
      {
        path: 'mine/recharge',
        name: 'MineRecharge',
        meta: { title: '去充值' },
        component: () => import('../views/mine/Recharge.vue')
      },
      {
        path: 'mine/notices',
        name: 'MineNotices',
        meta: { title: '我的通知' },
        component: () => import('../views/mine/Notifications.vue')
      },
      {
        path: 'mine/about',
        redirect: '/mine/join'
      },
      {
        path: 'mine/join',
        name: 'MineJoin',
        meta: { title: '加入我们' },
        component: () => import('../views/mine/JoinUs.vue')
      },
      {
        path: 'mine/feedback',
        name: 'MineFeedback',
        meta: { title: '意见反馈' },
        component: () => import('../views/mine/Feedback.vue')
      },
      {
        path: 'draw-rule',
        name: 'DrawRule',
        meta: { title: '画规' },
        component: () => import('../views/DrawRule.vue')
      },
      {
        path: 'shrink-tool',
        name: 'ShrinkTool',
        meta: { title: '缩水工具' },
        component: () => import('../views/ShrinkTool.vue')
      },
      {
        path: 'shrink-tool/filter-king',
        name: 'FilterKingTool',
        meta: { title: '过滤王' },
        component: () => import('../views/shrink-tool/FilterKingTool.vue')
      },
      {
        path: 'shrink-tool/filter-king-five',
        name: 'FiveFilterKingTool',
        meta: { title: '五星缩水' },
        props: { starCount: 5 },
        component: () => import('../views/shrink-tool/FilterKingTool.vue')
      },
      {
        path: 'shrink-tool/three',
        name: 'ThreeShrinkTool',
        meta: { title: '三星选号' },
        component: () => import('../views/shrink-tool/ThreeShrinkTool.vue')
      },
      {
        path: 'shrink-tool/three/result',
        name: 'ThreeShrinkResult',
        meta: { title: '过滤结果' },
        component: () => import('../views/shrink-tool/ThreeShrinkResult.vue')
      },
      {
        path: 'shrink-tool/help',
        name: 'ThreeShrinkHelp',
        meta: { title: '使用帮助' },
        component: () => import('../views/shrink-tool/ThreeShrinkHelp.vue')
      },
      {
        path: 'trend/fc3d',
        name: 'Fc3dTrend',
        meta: { title: '走势图' },
        component: () => import('../views/trend/Fc3dTrend.vue')
      },
      {
        path: 'tool/bet-multiplier',
        name: 'BetMultiplierTool',
        meta: { title: '倍投计算' },
        component: () => import('../views/tool/BetMultiplierTool.vue')
      },
      {
        path: 'tool/wave-calculator',
        name: 'WaveCalculatorTool',
        meta: { title: '推波计算' },
        component: () => import('../views/tool/WaveCalculatorTool.vue')
      },
      {
        path: 'tool/probability-calculator',
        name: 'ProbabilityCalculatorTool',
        meta: { title: '概率计算' },
        component: () => import('../views/tool/ProbabilityCalculatorTool.vue')
      },
      {
        path: 'tool/golden-split',
        name: 'GoldenSplitTool',
        meta: { title: '黄金分割' },
        component: () => import('../views/tool/GoldenSplitTool.vue')
      },
      {
        path: 'tool/base-validation',
        name: 'BaseValidationTool',
        meta: { title: '大底验证' },
        component: () => import('../views/tool/BaseValidationTool.vue')
      },
      {
        path: 'tool/number-intersection',
        name: 'NumberIntersectionTool',
        meta: { title: '号码交集' },
        component: () => import('../views/tool/NumberIntersectionTool.vue')
      },
      {
        path: 'login',
        name: 'Login',
        meta: { title: '用户登录', authMode: 'login' },
        component: () => import('../views/AuthPage.vue')
      },
      {
        path: 'register',
        name: 'Register',
        meta: { title: '用户注册', authMode: 'register' },
        component: () => import('../views/AuthPage.vue')
      },
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        meta: { title: '忘记密码', authMode: 'forgot' },
        component: () => import('../views/AuthPage.vue')
      },
      {
        path: 'agreement/user',
        name: 'UserAgreement',
        meta: { title: '用户服务协议' },
        component: () => import('../views/Agreement.vue')
      },
      {
        path: 'agreement/privacy',
        name: 'PrivacyPolicy',
        meta: { title: '隐私政策' },
        component: () => import('../views/Agreement.vue')
      },
      {
        path: 'install',
        name: 'Install',
        meta: { title: '应用下载' },
        component: () => import('../views/Install.vue')
      },
      // 详情页路由
      {
        path: 'detail/LotteryHistory',
        meta: { title: '长条' },
        component: () => import('../views/detail/LotteryHistory.vue')
      },
      {
        path: 'detail/LotteryDraw',
        meta: { title: '开奖查询' },
        component: () => import('../views/detail/LotteryDraw.vue')
      },
      {
        path: 'detail/Oneiromancy',
        meta: { title: '梦册' },
        component: () => import('../views/detail/Oneiromancy.vue')
      },
      {
        path: 'detail/OneiromancyResult',
        meta: { title: '解梦' },
        component: () => import('../views/detail/OneiromancyResult.vue')
      }
    ] 
  },

  // 404路由
  {
    path: '*',
    component: () => import('../views/404.vue')
  }
]

const router = new VueRouter({
  mode: process.env.VUE_APP_ROUTER_MODE === 'hash' ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes
})

const whiteList = ['/', '/manual-plan', '/manual-plan/detail', '/login', '/register', '/forgot-password', '/agreement/user', '/agreement/privacy', '/install']

router.beforeEach((to, from, next) => {
  if (to.path === '/shrink-tool' && ['PL5', 'QXC'].includes(String(to.query.lotteryCode || '').toUpperCase())) {
    next({
      path: '/shrink-tool/filter-king',
      query: to.query
    })
    return
  }
  const token = localStorage.getItem('front_token')
  if (token || whiteList.includes(to.path)) {
    next()
    return
  }
  next({
    path: '/login',
    query: { redirect: to.fullPath }
  })
})

export default router
